export default __webpack_public_path__ + "static/media/luas-black.650618e0.svg";